import { KnownLocation } from "../models/KnownLocation";
import { KnownRole } from "../models/KnownRole";
import { RoleBundleMapping } from "../models/LTOSetup";
import { UserRole } from "../models/MyRole";
import { PostUpdateSubscriptionsRequest } from "../models/PostUpdateSubscriptionsRequest";
import { RoleBundle } from "../models/RoleBundle";
import { SkillData } from "../models/SkillData";

export const GET_MY_ROLES = "GET_MY_ROLES";
export const GET_KNOWN_ROLES = "GET_KNOWN_ROLES";
export const UPDATE_ROLE_SUBSCRIPTIONS = "UPDATE_ROLE_SUBSCRIPTIONS";
export const GET_ROLE_BUNDLES = "GET_ROLE_BUNDLES";
export const GET_ROLE_BUNDLE_MAPPINGS = "GET_ROLE_BUNDLE_MAPPINGS";
export const GET_SKILL_DATA = "GET_SKILL_DATA";

export interface GetMyRoles {
  type: typeof GET_MY_ROLES;
  payload: UserRole | undefined;
}

export interface GetKnownRoles {
  type: typeof GET_KNOWN_ROLES;
  payload: { roles: Array<KnownRole>; locations: Array<KnownLocation> } | undefined;
}

export interface UpdateRoleSubscriptions {
  type: typeof UPDATE_ROLE_SUBSCRIPTIONS;
  payload: PostUpdateSubscriptionsRequest | undefined;
}

export interface GetRoleBundles {
  type: typeof GET_ROLE_BUNDLES;
  payload: Array<RoleBundle>;
}

export interface GetRoleBundleMappings {
  type: typeof GET_ROLE_BUNDLE_MAPPINGS;
  payload: Array<RoleBundleMapping>;
}

export interface GetSkillData {
  type: typeof GET_SKILL_DATA;
  payload: Array<SkillData>;
}

export type RoleActions =
  | GetMyRoles
  | GetKnownRoles
  | UpdateRoleSubscriptions
  | GetRoleBundles
  | GetRoleBundleMappings
  | GetSkillData;
